import React from 'react';
import { Typography, Box, useTheme } from '@mui/material';
import { useLanguage } from '../../shared/contexts/LanguageContext';

export const BackToTop: React.FC = () => {
  const theme = useTheme();
  const { language } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box sx={{ textAlign: 'center', mt: theme.spacing(8) }}>
      <Typography
        variant="body2"
        color="primary"
        onClick={scrollToTop}
        sx={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: theme.spacing(1),
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        ↑ {language === 'de' ? 'Nach oben' : 'Back to Top'}
      </Typography>
    </Box>
  );
};
